import type { InertiaAppConfig } from '@inertiajs/core';
/**
 * Shared Inertia.js configuration for both client and SSR entrypoints.
 * Must be kept in sync to prevent hydration mismatches.
 */
export type InertiaAppConfigDefaults = Partial<InertiaAppConfig>;

export const INERTIA_DEFAULTS: InertiaAppConfigDefaults = {
  // https://github.com/inertiajs/inertia-rails/blob/24e841f70a7734219ea85f79e7ce19a828208652/lib/generators/inertia/install/templates/react/inertia.tsx#L46
  future: {
    // https://inertia-rails.dev/guide/configuration#use-script-element-for-initial-page
    useScriptElementForInitialPage: true,
    preserveEqualProps: true,
    useDataInertiaHeadAttribute: true,
    useDialogForErrorModal: false,
  },
};
